import StickyPageHeader from '../components/common/StickyPageHeader';
import PasswordChangePanel from '../components/panels/PasswordChangePanel';
import Layout from '../layout';

const AdminPasswordPage = ({ disableLayout, routes }) => {
  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Update Password" />
      <PasswordChangePanel id="password" title="Change Admin Password" />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminPasswordPage;
